if (!customElements.get('fp-attached-photo')) {
  customElements.define('fp-attached-photo', class extends HTMLElement {
    connectedCallback() {
      const image = this.querySelector('img');
      if (!image) return;
      const fallback = () => {
        const thumbnail = image.closest('.fp-cart-photo__thumb');
        if (thumbnail) thumbnail.hidden = true;
      };
      image.addEventListener('error', fallback, { once: true });
      if (image.complete && image.naturalWidth === 0) fallback();
    }
  });
}
